import React from "react";

import { wrap } from "./RydTestbedWrap";
import PlaybackCaretIndicatorDialog from "../components/dialogs/playback/PlaybackCaretIndicatorDialog";
import { MetronomeInputBox } from "../components/pickers/ContextMetronome";
import {
    MetronomeMarking,
    NoteDuration,
    TimeSignature
} from "../model/core";
import TimeSignatureInputBox from "../components/ContextTimeSignature";
import { ComputedContextFrame } from "../model/context";


export function PlaybackCaretIndicatorDialogTestbed() {
    const [metronome, setMetronome] = React.useState<MetronomeMarking>(new MetronomeMarking(120, new NoteDuration(16)));
    const [timeSignature, setTimeSignature] = React.useState<TimeSignature>(new TimeSignature(4, 4));
    const cf = new ComputedContextFrame()
    cf.metronome = metronome;
    cf.timeSignature = timeSignature;

    return wrap(<>
        {/* Add your testbed components here */}
        <h1>Playback Caret Indicator Testbed</h1>
        <MetronomeInputBox metronome={metronome} setMetronomeCB={setMetronome} />
        <TimeSignatureInputBox timeSignature={timeSignature} setTimeSignatureCB={setTimeSignature} />
        <br />
        <PlaybackCaretIndicatorDialog
            ticksLength={234}
            ppq={480}
            contextFrame={cf}
        />
        <br />
        <PlaybackCaretIndicatorDialog
            ticksLength={123}
            ppq={480}
            contextFrame={cf}
        />
    </>);
}